import { createEffect, createEvent, createStore, sample } from 'effector';
import { api, unwrap, type Schemas } from '../../shared/api/client';
import type { SortState } from '../../shared/ui';

export const statsRequested = createEvent();
export const sortChanged = createEvent<SortState>();

export const loadStatsFx = createEffect(() => unwrap(api.GET('/api/v1/stats')));

export const $stats = createStore<Schemas['StatsOut'] | null>(null).on(
  loadStatsFx.doneData,
  (_, s) => s,
);
export const $sort = createStore<SortState>({ column: 'closed', direction: 'desc' }).on(
  sortChanged,
  (_, s) => s,
);

// Loaded when the page opens: closed positions only change through actions taken elsewhere.
sample({ clock: statsRequested, target: loadStatsFx });
